<template>
<div v-show="store.state.currentScreen === 'my-phaser-container'">
    <div class="top-bar">
        <div
            v-for="(tool, i) in topTools" :key="i"
            class="tool-entry"
            :class="getToolClass(tool)"
            @pointerdown="clickTool(tool)"
        >
            <img
                v-if="isStandardTool(tool)"
                :src="getTexture(tool)"
                :title="t(`${tool.name.toLowerCase()} tool tip`, tool.name)"
            >
            <label
                v-else
                class="image-tool-label"
                for="load-image-top"
            >
                <input
                    id="load-image-top"
                    type="file"
                    @change="readImage('load-image-top')"
                    accept="image/*"
                />
            </label>
        </div>
    </div>

    <div class="right-bar" v-if="rightTools.length && showMore">
        <div
            v-for="(tool, i) in rightTools" :key="i"
            class="tool-entry"
            :class="getToolClass(tool)"
            @pointerdown="clickTool(tool)"
        >
            <img
                v-if="isStandardTool(tool)"
                :src="getTexture(tool)"
                :title="t(`${tool.name.toLowerCase()} tool tip`, tool.name)"
            >
            <label
                v-else
                class="image-tool-label"
                for="load-image-right"
            >
                <input
                    id="load-image-right"
                    type="file"
                    @change="readImage('load-image-right')"
                    accept="image/*"
                />
            </label>
        </div>
    </div>

    <div :class="isIOS ? 'bottom-panel-ipad': 'bottom-panel'" v-if="store.state.showingPanel">
        <div
            v-for="(tool, i) in panelTools" :key="i"
            class="tool-entry"
            :class="getToolClass(tool)"
            @pointerdown="clickTool(tool, true)"
        >
            <img :src="getTexture(tool)" :title="t(`${tool.name.toLowerCase()} tool tip`, tool.name)">
        </div>
        <div class="userimage-sliders" v-if="store.state.showingPanel === 'userImage'">
            <input type="range" class="userimage-slider" min="0" max="100" v-model="imageSize">
            <input type="range" class="userimage-slider" min="0" max="100" v-model="imageOpacity">
        </div>
    </div>

</div>

</template>

<script>
import { userimage } from '../myapp/src/tools/userimage';
import { isIOS } from '../myapp/src/core/environment';
import { myInput } from '../myapp/src/input';
export default {
    data() {
        return {
            isIOS,
            width: window.innerWidth,
            imageSize: 50,
            imageOpacity: 100,
            showMore: false,
            moreTool: {
                name: 'Show more',
                texture: 'more_tools',
                onClick: () => {this.showMore = !this.showMore}
            }
        }
    },
    watch: {
        imageOpacity: function () {
            userimage.image.setAlpha(this.imageOpacity / 100);
        },
        imageSize: function () {
            const a = this.imageSize * 3;
            const b = a < 150 ?
                0.5 + (a / 300):
                1 + ((a - 150) / 30);
            userimage.image.setScale(b);
            userimage.updateHandle();
        }
    },
    computed: {
        topTools: function () {
            if (this.howManyFit >= 26) {
                return this.store.state.tools.filter(t => !t.panel).slice(0, this.howManyFit);
            }
            return this.store.state.tools.filter(t => !t.panel).slice(0, this.howManyFit - 1).concat(this.moreTool);
        },
        rightTools: function () {
            if (this.howManyFit >= 26) {
                return [];
            }
            return this.store.state.tools.filter(t => !t.panel).slice(this.howManyFit - 1);
        },
        panelTools: function () {
            return this.store.state.tools.filter(tool => tool.panel === this.store.state.showingPanel);
        },
        howManyFit: function () {
            return Math.floor((this.width - 10) / 38);
        }
    },
    methods: {
        isStandardTool(tool) {
            if (tool.name !== 'Image') return true;
            if (userimage.image) return true;
            return false;
        },
        getTexture(tool) {
            return require(`../../public/images/${tool.texture}.png`);
        },
        getToolClass(tool) {
            let result = ''
            if (this.isStandardTool(tool)) result += 'special-image-tool ';
            if (tool.disabled) result += 'disabled';
            if (tool.isFocused) result += 'selected';
            return result;
        },
        clickTool(tool, fromBottom) {
            if (tool.disabled) return;

            // The following line fixes the clone tool deselecting all beads when over an empty bead
            // It is not the neatest solution (leads to race conditions) and could be improved!
            if (fromBottom) myInput.tempBanPointer();

            tool.onClick();
        },
        readImage(id) {
            userimage.readImage(id);
        },
    },
    mounted() {
        this.ee.on('resize', () => {
            this.width = window.innerWidth;
        });
    }
}
</script>

<style lang="scss">
@import '../assets/colors.scss';

.special-image-tool {
    position: relative;
}

.image-tool-label {
    width: 32px;
    height: 32px;
    background-image: url('../../public/images/image.png');
    background-size: cover;
    &:hover {
        cursor: pointer;
    }
    input {
        display: none;
    }
}

.top-bar {
    position: absolute;
    top: 0px;
    height: 38px;
    width: calc(min(1790px, 100vw));
    padding: 5px;
    z-index: 1;
    background-color: $light_grey;
    .tool-entry {
        display: inline-block;
    }
}

.right-bar {
    position: absolute;
    right: 0px;
    top: 42px;
    width: 38px;
    padding: 5px;
    z-index: 1;
    background-color: $light_grey;
}

.bottom-panel {
    position: absolute;
    left: 67px;
    top: calc(min(950px, 100vh - 50px));
    padding: 5px;
    z-index: 2;
    background-color: $light_grey;
    .tool-entry {
        display: inline-block;
    }
    .userimage-sliders {
        display: inline-block;
    }
}

.bottom-panel-ipad {
    position: absolute;
    left: 80px;
    top: 60px;
    padding: 5px;
    z-index: 2;
    background-color: $light_grey;
    .tool-entry {
        display: inline-block;
    }
    .userimage-sliders {
        display: inline-block;
    }
}

.tool-entry {
    background-color: $light_grey;
    user-select: none;
    padding: 3px;
    width: 32px;
    height: 32px;
    &:hover {
        background-color: white;
        cursor: pointer;
    }
    &.selected {
        background-color: white;
    }
    &.disabled {
        img {
            opacity: 0.35;
        }
        &:hover {
            background-color: rgb(231, 231, 231);
            cursor: default;
        }
    }
    img {
        width: 100%;
        height: 100%;
    }
}
</style>